import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { Link } from "react-router-dom";
function Login({ setToken }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const registerSuccessMessage = localStorage.getItem(
      "registerSuccessMessage"
    );
    if (registerSuccessMessage) {
      toast.success(registerSuccessMessage);
      setTimeout(() => {
        localStorage.removeItem("registerSuccessMessage");
      }, 2000);
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("email", email);
      formData.append("password", password);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}dlogin`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log(response);
      if (response.data.status === "success") {
        sessionStorage.setItem("token", "loggedIn");
        // Set the token in App.js via setToken
        setToken("loggedIn");
        navigate("/"); // Redirect to the dashboard or home
      } else {
        toast.error(response.data.message || "Invalid credentials");
      }
    } catch (error) {
      console.error("Login Error:", error);
      toast.error(error.response.data.detail);
    }
  };

  return (
    <>
      <ToastContainer position="top-center" autoClose={4000} />
      <div
        className="d-flex align-items-center justify-content-center vh-100 bg_header "
        style={{
          background:
            "url('https://img.freepik.com/free-vector/ai-technology-microchip-background-vector-digital-transformation-concept_53876-117808.jpg?uid=R108868518&ga=GA1.1.1358864381.1725960411&semt=ais_hybrid') center/cover",
        }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div
              className="col-md-6 p-5 form_login rounded shadow-lg"
              style={{
                background: "rgba(255, 255, 255, 0.2)",
                backdropFilter: "blur(10px)",
                WebkitBackdropFilter: "blur(10px)",
                borderRadius: "10px",
              }}
            >
              <h2 className="text-center mb-4 text-white">Login</h2>
              <form onSubmit={handleLogin}>
                <div className="mb-3">
                  <label className="form-label text-white">Email Address</label>
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    name="email"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label text-white">Password</label>
                  <input
                    type="password"
                    name="password"
                    className="form-control"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>
                <div className="d-flex justify-content-between">
                  <Link to="/forgot-password" className="text-light">
                    Forgot Password?
                  </Link>
                </div>
                <button
                  type="submit"
                  className="btn btn-light w-100 mt-3 fw-bold"
                >
                  Login
                </button>
                <div className="text-center mt-3 text-white">
                  Don't have an account?{" "}
                  <Link to="/register" className="text-light">
                    Register
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>


        {/* Enquiry Form  start*/}
        {/* <div className="form-wrapper">
          <div className="video-bg">
            <video autoPlay muted loop playsInline>
              <source
                src="https://media.istockphoto.com/id/1453963806/video/time-lapse-low-angle-of-tall-corporate-buildings-skyscraper-with-reflection-of-clouds-among.mp4?s=mp4-640x640-is&k=20&c=RIpYsVqpNXm-KOaMcpsMY80maM3p2SyEbjTTMxTqzz8="
                type="video/mp4"
              />
              Your browser does not support HTML5 video.
            </video>
          </div>
          <div className="overlay" />
          <div className="form-container">
            <div className="form-card">
              <div className="form-title">Enquiry Form</div>
              <form>
                <div className="mb-3">
                  <label htmlFor="fullName" className="form-label">Full Name *</label>
                  <input type="text" className="form-control" id="fullName" placeholder="Your Name" required />
                </div>

                <div className="mb-3">
                  <label htmlFor="email" className="form-label">Email Address *</label>
                  <input type="email" className="form-control" id="email" placeholder="you@example.com" required />
                </div>

                <div className="mb-3">
                  <label htmlFor="phone" className="form-label">Phone Number *</label>
                  <input type="tel" className="form-control" id="phone" placeholder="+91 98765 43210" required />
                </div>

                <div className="mb-3">
                  <label htmlFor="property" className="form-label">Interested Property</label>
                  <select className="form-select" id="property">
                    <option disabled selected>Select a property</option>
                    <option>Luxury Villa – Ocean Heights</option>
                    <option>3BHK Apartment – Urban Greens</option>
                    <option>Commercial Office – BizHub Tower</option>
                  </select>
                </div>

                <div className="mb-3">
                  <label htmlFor="message" className="form-label">Message / Requirements</label>
                  <textarea
                    className="form-control"
                    id="message"
                    rows="4"
                    placeholder="Let us know your needs..."
                  ></textarea>
                </div>

                <button type="submit" className="btn btn-submit w-100">Submit Inquiry</button>
              </form>
            </div>
          </div>
        </div> */}
        {/* Enquiry Form  End*/}
      </div>
    </>
  );
}

export default Login;
